export default __webpack_public_path__ + "static/media/tablet.0aa3caff.svg";